import { BUILT_HOME_UNASSIGNED_FILTER } from './builtProjectUtils';

export const UNASSIGNED_CONSULTANT_FILTER_VALUE = '__unassigned_consultant__';
export const USER_CONSULTANT_FILTER_PREFIX = 'user:';
export const MANUAL_CONSULTANT_FILTER_PREFIX = 'manual:';

export function getAssignmentFilterOptions(homes, field, preferredValues) {
  const preferred = preferredValues.filter((value) => value !== BUILT_HOME_UNASSIGNED_FILTER);
  const preferredSet = new Set(preferred);
  const additionalValues = [...new Set((homes || [])
    .map((home) => String(home?.[field] || '').trim())
    .filter((value) => (
      value
      && value !== BUILT_HOME_UNASSIGNED_FILTER
      && !preferredSet.has(value)
    )))]
    .sort((a, b) => a.localeCompare(b));

  return [...preferred, ...additionalValues, BUILT_HOME_UNASSIGNED_FILTER];
}

export function getConsultantFilterValue(home = {}) {
  if (home.salesConsultantId) {
    return `${USER_CONSULTANT_FILTER_PREFIX}${home.salesConsultantId}`;
  }

  const manualName = String(home.salesConsultantManualName || home.salesConsultantName || '').trim();
  if (manualName) return `${MANUAL_CONSULTANT_FILTER_PREFIX}${manualName}`;
  return UNASSIGNED_CONSULTANT_FILTER_VALUE;
}

export function getConsultantFilterOptions(homes = []) {
  const optionsByValue = new Map();

  homes.forEach((home) => {
    const value = getConsultantFilterValue(home);
    if (value === UNASSIGNED_CONSULTANT_FILTER_VALUE) return;
    const label = String(home.salesConsultantName || home.salesConsultantManualName || '').trim();
    if (label && !optionsByValue.has(value)) optionsByValue.set(value, label);
  });

  return [
    ...[...optionsByValue.entries()]
      .map(([value, label]) => ({ value, label }))
      .sort((a, b) => a.label.localeCompare(b.label)),
    { value: UNASSIGNED_CONSULTANT_FILTER_VALUE, label: 'Unassigned' },
  ];
}
